import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index.js'
//导入进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

Vue.use(VueRouter)

import {isMobile} from '@/components/util/equipmentUtil.js'
// pc
import routes from './pc-router.js'
// mobile
import mobileRouter from './mobile-router.js'

const router = new VueRouter({
  routes : isMobile ? mobileRouter : routes
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})

router.afterEach((to, from) => {
  NProgress.done()
  if (!isMobile) {
    // 导航默认颜色设置
    let finalColor = to.meta && to.meta.topMenuThem ? to.meta.topMenuThem : '#ffffff'
    store._mutations['pc/changeMenuBackgroundMutation'][0](finalColor)
    // 自动滚动到顶部
    let dom = document.querySelector('.el-main')
    if(dom){
        dom.scrollTop = 0
    }
  } else {
    // 自动滚动到顶部
    let dom = document.querySelector('.content-box')
    if (dom) {
      dom.scrollTop = 0
    }
  }

})

export default router

export let routerData = isMobile ? (mobileRouter.find(item => item.path==='/home')).children: (routes.find(item => item.path==='/home')).children
